import { useState } from 'react'
import { useDispatch } from 'react-redux'

import { useEnforceUpgrade } from 'components/billing/useEnforceUpgrade'
import { fetchStatistics } from 'features/organization_statistics'

export const useTriggerSeatsPaywall = ({ onInviteOpen, onNoSeatsOpen, totalSeatsRef }) => {
  const dispatch = useDispatch()
  const [triggerState, setTriggerState] = useState(null)
  const onUpgradeSubscription = () => setTriggerState('upgrade-modal-open')
  const enforceUpgrade = useEnforceUpgrade('organization_invitation', { onUpgradeSubscription })

  const trigger = async () => {
    try {
      await enforceUpgrade(async () => {
        const statistics = await dispatch(fetchStatistics()).unwrap()
        totalSeatsRef.current = statistics.occupancy_capacity
        if (statistics.available_seats > 0) {
          onInviteOpen()
          setTriggerState('invite-modal-open')
        } else {
          onNoSeatsOpen()
          setTriggerState('no-seats-modal-open')
        }
      })
    } catch {
      // If seat statistics fail, still open invite flow instead of doing nothing.
      onInviteOpen()
      setTriggerState('invite-modal-open')
    }
  }

  return [
    trigger,
    triggerState,
    () => setTriggerState(null),
  ]
}
